import React from 'react'
import { useAlert } from "components/Alerts/hooks"
import { AbilityContext } from "components/Permissions/Can"
import { app } from "router/routes"
import { alerts, features } from "keys"
import { isEmpty } from "lodash"
import { useCallback, useContext } from "react"
import { useNavigate } from "react-router-dom"
import { ReactComponent as Dashboard1Icon } from 'assets/icons/Dashboard1.svg';
import { ReactComponent as Dashboard2Icon } from 'assets/icons/Dashboard2.svg';
import { ReactComponent as Dashboard3Icon } from 'assets/icons/Dashboard3.svg';
import { ReactComponent as Dashboard4Icon } from 'assets/icons/Dashboard4.svg';
import { DashboardContext } from '../DashboardContext'
import { secondary } from 'styles/theme'

const useDashboardCards = () => {
    const navigate = useNavigate()
    const ability = useContext(AbilityContext)
    const { dashboardData } = useContext(DashboardContext)

    const goAssessmentReview = () => navigate(app.assessmentExecutionTracking)
    const goPerformAssessments = () => navigate(app.performAssessments)
    const goAssessments = () => navigate(app.assessments)
    const goPayments = () => navigate(app.payments)

    const { setAlerts } = useAlert()

    const openTestTakerPopup = useCallback(() => {
        setAlerts(alerts.createTestTaker, true)
    }, [])

    const noTestTakers = dashboardData.total_test_takers_count === 0
    const loading = isEmpty(dashboardData)

    const students = ability.can("read", "student-label") ? "תלמידים" : "ילדים"
    const student = ability.can("read", "student-label") ? "תלמיד" : "ילד"


    const cards = React.useMemo(
        () => [
            {
                id: 0,
                loading: loading,
                value: dashboardData.total_test_takers_count,
                button: {
                    label: `להוספת ${student}`,
                    color: noTestTakers ? "secondary" : "light",
                    action: openTestTakerPopup,
                    feature: "test-takers",
                    permissionHOC: "hidden",
                    role: "read"
                },
                icon: Dashboard1Icon,
                title: "יש לך במערכת",
                text: "תלמידים"
            },
            {
                id: 1,
                title: "עד היום בוצעו",
                text: "מבדקים",
                loading: loading,
                value: dashboardData.total_performed_count,
                button: {
                    label: "לצפיה בדוחות",
                    color: noTestTakers ? 'light' : "secondary",
                    action: goAssessments,
                    // blink: dashboardData.pending_assessments_count > 0,
                    disabled: !dashboardData.total_performed_count,
                    disabledColor: "gray2",
                    feature: "assessments",
                    permissionHOC: "hidden",
                    role: "read"
                },
                icon: Dashboard2Icon
            },
            {
                id: 2,
                loading: loading,
                title: "בסמסטר האחרון בוצעו",
                text: "מבדקים",
                value: dashboardData.current_performed_count || 0,
                button: {
                    label: "לנתוני ביצוע",
                    color: 'light',
                    action: goAssessmentReview,
                    disabledColor: "gray2",
                    feature: features.general_performance_review,
                    permissionHOC: "hidden",
                    role: "read"
                },
                icon: Dashboard3Icon
            },
            {
                id: 3,
                value: dashboardData.pending_count || 0,
                title: "מחכים לביצוע",
                text: "מבדקים",
                button: {
                    label: "לביצוע מבדקים",
                    color: 'light',
                    action: goPerformAssessments,
                    disabledColor: "gray2",
                    feature: "perform-assessments",
                    permissionHOC: "hidden",
                    role: "read"
                },
                icon: Dashboard4Icon
            }
        ], [dashboardData]
    );

    return cards
}

export default useDashboardCards